<template>

    <transition
        name="cta-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut">

        <!-- INTERACTION CTA -->
        <div class="interaction-cta noselect" v-bind:class="{ tablet: isTablet }" v-if="(hasEntered && display)">

            <div class="inner" v-if="!isTablet">
                <div class="icon">
                    <img src="/static/images/icon-move@1x.png" srcset="/static/images/icon-move@1x.png 1x, /static/images/icon-move@2x.png 2x, /static/images/icon-move@3x.png 3x" alt="" />
                </div>
                <div class="label">{{ message }}</div>
            </div>

            <div class="inner" v-else>
                <div class="icon">
                    <img src="/static/images/icon-touch@1x.png" srcset="/static/images/icon-touch@1x.png 1x, /static/images/icon-touch@2x.png 2x, /static/images/icon-touch@3x.png 3x" alt="" />
                </div>
                <div class="icon">
                    <img src="/static/images/icon-pinch@1x.png" srcset="/static/images/icon-pinch@1x.png 1x, /static/images/icon-pinch@2x.png 2x, /static/images/icon-pinch@3x.png 3x" alt="" />
                </div>
            </div>

        </div>
        <!-- END INTERACTION CTA -->

    </transition>

</template>


<script>

    let vm = {};

    export default {

        name: 'interaction-cta',

        components: {},

        data() {
            return {
                message: 'Click and drag your mouse to explore the full coverage of the Equipment Breakdown example home.',
                display: false
            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.state.interactive.entered;
            },

            instructed() {
                return this.$dataStore.getters.getInstructedState;
            },

            surgeState() {
                return this.$dataStore.getters.getPowerSurgeState;
            },

            isTablet() {
                return !!vm.$md.tablet();
            }

        },

        created() {
            //console.info('%cInteractionCTA::created', 'color:dodgerblue;');

            vm = this;

            this.$eventBus.$on('cta:show', vm.show);
            this.$eventBus.$on('cta:hide', vm.hide);
        },

        mounted() {
            //console.info('%cInteractionCTA::mounted', 'color:green;');

            vm = this;
        },

        methods: {

            show() {
                if (!this.surgeState && !this.instructed) {
                    this.display = true;
                    this.$dataStore.dispatch('INSTRUCTED', { val: true });
                    ('mousedown touchmove'.split(' ')).forEach(function(evt) {
                        window.addEventListener(evt, vm.hide, false);
                    });
                }
            },

            hide() {
                this.display = false;
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .interaction-cta {
        background-color: $white-95;
        width: 100%;
        max-width: 320px;
        padding: 8px 10px;
        border-radius: 5px;
        box-shadow: 0 0 2px $black-45;
        overflow: hidden;
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 999;
        pointer-events: none;
        transform-origin: 50% 50%;
        transform: translateX(-50%) translateY(-50%);
        animation-duration: 0.6s;
        animation-delay: 0.15s;
        animation-timing-function: $easeInOutQuad;

        &.tablet {
            width: auto;

            & .icon {
                padding: 8px 12px 8px 16px;

                & + .icon {
                    padding: 8px 16px 8px 12px;
                }

                & > img {
                    height: auto;
                    max-height: 48px;
                }
            }


        }

        & > .inner {
            width: 100%;
            height: 100%;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            position: relative;
        }

        & .icon {
            color: var(--color-base-text);
            padding: 0 10px 0 0;
            flex: 0 0 auto;

            & + .icon {
                padding: 0 0 0 10px;
            }

            & > img {
                display: block;
            }
        }

        & .label {
            font-family: $font-univers-std;
            font-size: 0.625rem;
            line-height: 1.250;
            letter-spacing: initial;
            color: var(--color-base-text);
            text-align: left;
            max-width: 100%;
            flex: 1 1 auto;
        }
    }

</style>


// WEBPACK FOOTER //
// InteractionCTA.vue?4dcb58be